<template>
	<div class="commonweal">
		<waterfall :align="align" :line-gap="210" :min-line-gap="120" :max-line-gap="300" :single-max-width="300" ref="waterfall">
			<!-- each component is wrapped by a waterfall slot -->
			<waterfall-slot :width="volunteerImg.width" :height="volunteerImg.width/volunteerImg.height>1.2?volunteerImg.height*1.4:volunteerImg.height*1.15" move-class="item-move" v-for="(volunteerImg, index) in volunteerImgs" :key="index">
				<div class="outer-box">
					<div class="item">
						<img class="wc-preview-img" :src="volunteerImg.s_img" @click="$preview($event, Imgs, index)">
					</div>
					<div class="item-content">
						<p>{{volunteerImg.s_description}}</p>
						<!-- <p class="font-a9 alignRight">
							<span @click="admireIt(volunteerImg.s_recno, index)">
								<img src="../../../static/image/logo/zan.png" class="alignMiddle">
								<span class="admire-num" v-text="volunteerImg.i_num"></span>
							</span>
						</p> -->
					</div>
				</div>
			</waterfall-slot>
		</waterfall>
		<!-- <div v-else>暂无图片</div> -->
	</div>
</template>

<script>
	import Vue from 'vue';
	import { Toast } from 'mint-ui';
	import Waterfall from 'vue-waterfall/lib/waterfall';
	import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot';
	import wcView from 'wc-view';
	import 'wc-view/style.css';
	Vue.use(wcView);
	import {getVolunteerImgs, admireImg} from '@/api/article';
	export default {
		name: 'VerticalFall',
		components: {
			Waterfall,
			WaterfallSlot,
		},
		props:['volunteerImgs', 'Imgs'],
		data() {
			let appid = localStorage.getItem("myOpenId");
			return {
				align: 'center',
				isBusy: false,
				appid: appid
			}
		},
		methods: {
			admireIt(recno, i){
				admireImg({imgNo: recno, appid: this.appid}).then(response => {
					let _data =  response.data;
					// console.log(_data);
					if(_data.errcode == "1"){
						Toast({
							message: '点赞成功',
							position: 'middle',
							duration: 1500
						});
						this.volunteerImgs[i].i_num = _data.data;
					}else{
						Toast({
							message: '已点赞',
							position: 'middle',
							duration: 1500
						});
					}
				});
			},
			/* getImgs(){
				if(this.volunteerImgs.length>0){
					console.log("111");
					for(var i = 0; i < this.volunteerImgs.length; i++) {
						this.imgs.push(this.volunteerImgs[i].s_img);
					}
				}
			}, */
		},
	}
</script>

<style lang="less">
	.margin10 {
		margin: 10px;
	}

	.commonweal {
		background-color: #fafafa;
		padding-bottom: 1em;
		margin: 0.5em 0.5em 0 0.5em;
	}

	.outer-box {
		background-color: #ffffff;
		border: 1px solid #f5f5f5;
		margin: 0.4rem;
	}

	.item-move {
		transition: all .5s cubic-bezier(.55, 0, .1, 1);
		-webkit-transition: all .5s cubic-bezier(.55, 0, .1, 1);
	}

	.item {
		margin: 0.625rem;

		img {
			width: 100%;
		}
	}

	.item:after {
		content: attr(index);
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		-webkit-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
	}

	.item-content {
		margin: 0.625rem;
		text-align: left;
		font-size: 12px;

		p {
			margin: 1em 0;
		}

		img {
			width: 14px;
			vertical-align: text-bottom;
			margin-right: 0.2em;
		}
	}

	.font-a9 {
		color: #aaa9a9;
	}

	.admire-num {
		display: inline-block;
		vertical-align: sub;
	}
</style>



// WEBPACK FOOTER //
// src/components/index/VerticalFall.vue